"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const translation_1 = require("../../common/js/helper/translation");
const Paths_1 = require("../constants/Paths");
const path_1 = require("../helper/path");
const product_1 = require("../helper/product");
const ProductSuggestionDropdown = ({ showDropdown, suggestedProducts, onClick, fullWidth, }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null, showDropdown && suggestedProducts && suggestedProducts.elements ? (react_1.default.createElement("div", { className: (0, classnames_1.default)('znd-product-suggestion-dropdown', fullWidth ? '--full-width' : null) }, suggestedProducts.elements.length > 0 ? (react_1.default.createElement(react_1.default.Fragment, null, suggestedProducts.elements.map((suggestedProduct) => (react_1.default.createElement(react_router_dom_1.Link, { key: suggestedProduct.id, to: (0, react_router_dom_1.generatePath)((0, path_1.localePath)(Paths_1.PATH_SHOP_PRODUCT), {
            product: suggestedProduct.productNumber,
        }), className: "znd-product-suggestion-dropdown__item", onClick: (event) => {
            if (onClick) {
                onClick(event, suggestedProduct);
            }
        } },
        react_1.default.createElement("div", { className: "znd-product-suggestion-dropdown__item__product-number t-body-small" }, suggestedProduct.productNumber),
        react_1.default.createElement("div", { className: "znd-product-suggestion-dropdown__item__product-name t-subhead-small" }, (0, product_1.isProductCategorySoftware)(suggestedProduct) &&
            suggestedProduct.translated?.customFields
                ?.massiveSoftwareConfigurationTitleInProductList
            ? suggestedProduct.translated.customFields
                .massiveSoftwareConfigurationTitleInProductList
            : suggestedProduct.translated?.name)))))) : (react_1.default.createElement("div", { className: "znd-product-suggestion-dropdown__no-results t-subhead-small" }, (0, translation_1.t)('product_suggestion_dropdown.no_results'))))) : null));
};
exports.default = (0, mobx_react_1.observer)(ProductSuggestionDropdown);
